import { indeedActions } from "./indeedActions";
import { technicusActions } from "./technicusActions";
import type { ActionHandlerMap } from "./types";
import { werkzoekenActions } from "./werkzoekenActions";

/**
 * Common actions available to all integrations.
 */
const commonActions: ActionHandlerMap = {
  // Refresh just triggers refetch via onSuccess callback
  refresh: async ({ onSuccess }) => {
    onSuccess?.();
  },
};

/**
 * Returns the action handler map for the given integration.
 * Merges common actions with integration-specific actions.
 */
export function getActionHandlers(integrationName: string): ActionHandlerMap {
  const integrationActions: Record<string, ActionHandlerMap> = {
    indeed: indeedActions,
    werkzoeken: werkzoekenActions,
    technicus: technicusActions,
  };
  return {
    ...commonActions,
    ...(integrationActions[integrationName.toLowerCase()] ?? {}),
  };
}

export { indeedActions } from "./indeedActions";
export { technicusActions } from "./technicusActions";
export { werkzoekenActions } from "./werkzoekenActions";
export type { ActionHandler, ActionHandlerMap, ActionParams } from "./types";
